export default "__VITE_ASSET__yO11382u__"